import { ScoreStarRating } from "../../../global/score/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

export const ListingScoreStarRating = () => {
  const listingRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );

  return (
    <ScoreStarRating
      starSize="1.5rem"
      spaceBetweenStars="0.125rem"
      maxValue={1}
      value={listingRedux.score}
    />
  );
};
